// Shared number formatting utilities
// Always use en-US locale for consistent display (commas for thousands, dots for decimals)

const formatterCache = {};

const getFormatter = (decimals) => {
  if (!formatterCache[decimals]) {
    formatterCache[decimals] = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }
  return formatterCache[decimals];
};

// Format a number with commas: 1234.5 → "1,234.50"
export const formatNumber = (value, decimals = 2) => {
  const num = Number(value) || 0;
  return getFormatter(decimals).format(num);
};

// Format as USD: 1234.5 → "$1,234.50"
export const formatMoney = (value, decimals = 2) => {
  return `$${formatNumber(value, decimals)}`;
};

// Format percentage: 12.345 → "12.35%"
export const formatPercent = (value, decimals = 2) => {
  return `${formatNumber(value, decimals)}%`;
};

// Compact money for chart axes: 12500 → "$13k"
export const formatCompactMoney = (value) => {
  const num = Number(value) || 0;
  if (Math.abs(num) >= 1000) {
    return `$${formatNumber(num / 1000, 0)}k`;
  }
  return formatMoney(num, 0);
};

// Replace internal source labels with user-friendly names, preserving metadata
export const friendlySourceName = (source) => {
  if (!source) return null;
  return source
    .replace(/master_cache_with_gaps/gi, 'Yahoo Finance')
    .replace(/master_cache/gi, 'Yahoo Finance')
    .replace(/yfinance/gi, 'Yahoo Finance');
};

// Strip score suffix from risk questionnaire options: "Less than 2 years (1)" → "Less than 2 years"
export const stripOptionScore = (text) => {
  return text.replace(/\s*\(\d+\)\s*$/, '');
};
